export function transformBlockProperties({ properties }) {
    return properties;
}
